import Breadcrumb from "@/components/base/Breadcrumb";

interface PageHeaderProps {
  title: string;
  description: string;
  breadcrumb: { label: string; to?: string }[];
  eyebrow?: string;
}

export default function PageHeader({ title, description, breadcrumb, eyebrow }: PageHeaderProps) {
  return (
    <section className="w-full px-4 md:px-6 pt-24 md:pt-28 pb-6 md:pb-8">
      <div className="rounded-lg bg-primary-950 px-6 md:px-10 py-8 md:py-10 relative overflow-hidden">
        <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-primary-800/60" />
        <div className="absolute -right-4 -bottom-20 w-44 h-44 rounded-full bg-accent-500/10" />
        <div className="relative z-10">
          <div className="mb-4 [&_a]:text-background-300 [&_a]:hover:text-accent-400 [&_span]:text-background-200">
            <Breadcrumb items={breadcrumb} />
          </div>
          {eyebrow && (
            <span className="inline-flex items-center gap-2 bg-accent-500/20 text-accent-300 text-xs font-medium px-3 py-1 rounded-full mb-3">
              <i className="ri-bookmark-3-line" />
              {eyebrow}
            </span>
          )}
          <h1 className="font-heading font-black text-3xl md:text-4xl text-background-50 tracking-tight">
            {title}
          </h1>
          <p className="text-sm md:text-base text-background-200 mt-3 max-w-2xl leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
}